<div class="configuration-step">
  <div class="step">{{item.title}}</div>
  <div class="answer" [ngClass]="{error: item.alert}">{{item.value?.name || item.value?.length}}</div>
</div>
